import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CheckBoxInput from 'components/forms/CheckboxInput'
import addIconChecked from 'assets/icons/add-icon-checked.png'
import minusIconChecked from 'assets/icons/minus-icon-checked.png'
import cn from 'classnames'
import ReactTooltip from 'react-tooltip'
import RightIcon from 'assets/icons/right-icon.png'

import styles from './sign-up-card.scss'

class SignUpCard extends Component {
  render() {
    const { optionInformation, onChangeOption, customStyle, onHandleDetail } = this.props

    const totalCount = optionInformation.count + optionInformation.available_count

    return (
      <li
        className={cn(styles['sign-up-card-wrapper'], {
          [styles['sign-up-card-disabled']]: totalCount === 0,
          [styles['sign-up-card-checked']]: optionInformation.isChecked
        })}
        style={customStyle}
      >
        <div className={styles['card-top']}>
          <ReactTooltip
            id={optionInformation.poll_option_id}
            effect="solid"
            place="bottom"
            backgroundColor="#9013FE"
            borderColor="#9013FE"
            className={styles['tooltip']}
          >
            <span>{optionInformation.description}</span>
          </ReactTooltip>

          <CheckBoxInput
            className={styles['check-box-button']}
            checked={optionInformation.isChecked}
            disabled={totalCount === 0}
            onChange={() =>
              onChangeOption({ type: 'checked', poll_option_id: optionInformation.poll_option_id })
            }
          />
          <div className={styles['card-info']}>
            <div className={styles['card-name']}>{optionInformation.item}</div>
            {optionInformation.description && (
              <div className={styles['card-description']} data-for={optionInformation.poll_option_id} data-tip>
                {optionInformation.description}
              </div>
            )}
          </div>
          {onHandleDetail && (
            <img
              src={RightIcon}
              className={styles['right-icon']}
              onClick={onHandleDetail}
              width="20"
            />
          )}
        </div>
        {optionInformation.count_limit === 9999 ? (
          <div className={styles['unlimited-text']}>unlimited</div>
        ) : (
          <div className={styles['card-bottom']}>
            <span>How many?</span>
            {totalCount === 0 ? (
              <span className={styles['completed-text']}>Completed</span>
            ) : (
              <div className={styles['button-wrapper']}>
                <div
                  className={styles['icon-wrapper']}
                  onClick={() =>
                    onChangeOption({
                      type: 'minus',
                      poll_option_id: optionInformation.poll_option_id
                    })
                  }
                >
                  <img src={minusIconChecked} width="10" />
                </div>
                <div className={styles['count-wrapper']}>
                  {optionInformation.count}&nbsp;of&nbsp;
                  {optionInformation.count + optionInformation.available_count}
                </div>
                <div
                  className={styles['icon-wrapper']}
                  onClick={() =>
                    onChangeOption({
                      type: 'add',
                      poll_option_id: optionInformation.poll_option_id
                    })
                  }
                >
                  <img src={addIconChecked} width="10" />
                </div>
              </div>
            )}
          </div>
        )}
      </li>
    )
  }
}

SignUpCard.propTypes = {
  optionInformation: PropTypes.object,
  onChangeOption: PropTypes.func,
  customStyle: PropTypes.object,
  onHandleDetail: PropTypes.func
}

export default SignUpCard



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/SignUp/SignUpDetail/SignUpCard/SignUpCard.jsx